/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, last: NonNullable<unknown> }} Coaching_Pdf_SummaryInputs */

const en_us2_coaching_pdf_summary = /** @type {(inputs: Coaching_Pdf_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workouts in the last 60 days: ${i?.count}. Last workout: ${i?.last}.`)
};

const pt_br2_coaching_pdf_summary = /** @type {(inputs: Coaching_Pdf_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treinos nos últimos 60 dias: ${i?.count}. Último treino: ${i?.last}.`)
};

const pt_pt2_coaching_pdf_summary = /** @type {(inputs: Coaching_Pdf_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treinos nos últimos 60 dias: ${i?.count}. Último treino: ${i?.last}.`)
};

/** @type {(inputs: Coaching_Pdf_SummaryInputs) => LocalizedString} */
const es_419_coaching_pdf_summary = en_us2_coaching_pdf_summary;

/** @type {(inputs: Coaching_Pdf_SummaryInputs) => LocalizedString} */
const fr_fr2_coaching_pdf_summary = en_us2_coaching_pdf_summary;

/** @type {(inputs: Coaching_Pdf_SummaryInputs) => LocalizedString} */
const de_de2_coaching_pdf_summary = en_us2_coaching_pdf_summary;

/** @type {(inputs: Coaching_Pdf_SummaryInputs) => LocalizedString} */
const it_it2_coaching_pdf_summary = en_us2_coaching_pdf_summary;

/**
* | output |
* | --- |
* | "Workouts in the last 60 days: {count}. Last workout: {last}." |
*
* @param {Coaching_Pdf_SummaryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_pdf_summary = /** @type {((inputs: Coaching_Pdf_SummaryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Pdf_SummaryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_pdf_summary(inputs)
	if (locale === "es-419") return es_419_coaching_pdf_summary(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_pdf_summary(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_pdf_summary(inputs)
	if (locale === "de-DE") return de_de2_coaching_pdf_summary(inputs)
	if (locale === "it-IT") return it_it2_coaching_pdf_summary(inputs)
	return en_us2_coaching_pdf_summary(inputs)
});
export { coaching_pdf_summary as "coaching.pdf_summary" }